// There is no reason for this to be stateful right now, but building it this way allows
// for a future implementation of changing settings to be immediately reflected on the user's
// device instead of requiring a refresh

export function getChatActions(content) {
  let actions = [];
  // chat
  let aLiveChatAction = content.GetActionById(CrowdHub_App.ACTION_LIVECHAT);
  if (aLiveChatAction) {
    let myCohorts = App.INSTANCE.CurrentUser.getCohorts()?.filter(cohort => cohort.Active == 'true');
    let cohortChannels;
    // filter out my cohort channels to know how many messengers we need
    if (CrowdHub_App.CONFIG.DISABLE_COHORT_SESSION_CHAT) {
      cohortChannels = [];
      myCohorts = [];
    } else {
      cohortChannels = content.Channels.filter(channel => {
        if (channel.type.includes('group_')) {
          let cohortId = channel.type.replace('group_', '');
          let isMine = false;
          if (!myCohorts) {
            return false;
          }
          for (let i = 0; i < myCohorts.length; i++) {
            if (myCohorts[i].Id == cohortId) {
              isMine = true;
            }
          }
          return isMine;
        } else {
          return false;
        }
      });
    }

    actions.push({
      id: 'chat',
      name: 'Chat',
      data: {
        channeltype: OTSessionContent.CHANNELTYPE_CHAT,
        action: aLiveChatAction,
        ActivityType: 'Chat',
        cohorts: myCohorts,
        cohortChannels: cohortChannels,
      },
    });
  }

  // add qa
  var aModerateQAAction = content.GetActionById(CrowdHub_App.ACTION_MODERATE_QA);
  var aVotingAction = content.GetActionById(CrowdHub_App.ACTION_VOTING);
  var aQAAction = content.GetActionById(CrowdHub_App.ACTION_QA);
  if (aQAAction) {
    if (aVotingAction != null) {
      aVotingAction = true;
    }

    actions.push({
      id: 'qa',
      name: 'Q&A',
      data: {
        channeltype: OTSessionContent.CHANNELTYPE_QA,
        action: aQAAction,
        showVoting: aVotingAction ? true : false,
        moderateFlow: aModerateQAAction ? true : false,
        ActivityType: 'Question',
      },
    });
  }

  // add polls
  var aPollAction = content.GetActionById(CrowdHub_App.ACTION_POLL);
  if (aPollAction) {
    actions.push({
      id: 'polls',
      name: 'Polls',
      data: {
        channeltype: OTSessionContent.CHANNELTYPE_POLL,
        action: aPollAction,
        ActivityType: 'Poll',
      },
    });
  }

  // add moderator chat for moderators
  // TODO: NEED TO CHECK IF OPENTOKSESSION.INSTANCE.IsMODERATOR is still necessary > SEE services_opentalk.php
  if (
    CrowdHub_App.CONFIG.ENABLED_MODERATOR_CHAT &&
    (OpentokSession.INSTANCE.isModerator() || App.INSTANCE.CurrentUser.isContentEditor(content))
  ) {
    actions.push({
      id: 'mod',
      name: 'Mod',
      data: {
        channeltype: OTSessionContent.CHANNELTYPE_MOD,
        ActivityType: 'Mod',
      },
    });
  }

  // add who's here for partners
  var aVisitorAwarenessAction = content.GetActionById(CrowdHub_App.ACTION_VISITOR_AWARENESS);
  if (
    aVisitorAwarenessAction &&
    ((content.FirstBucketName() == CrowdHub_App.BUCKET_PARTNER &&
      CrowdHub_App.CONFIG.PARTNER_ATTENDENCE_MODS_ONLY == false) ||
      (content.FirstBucketName() == CrowdHub_App.BUCKET_PARTNER && App.INSTANCE.CurrentUser.isContentEditor(content)))
  ) {
    actions.push({
      id: 'visitors',
      class: 'userlist',
      name: 'Visitors',
      style: '',
      data: {
        channeltype: OTSessionContent.CHANNELTYPE_UPDATE,
        messageClass: 'Message',
        showStatusUpdates: false,
        action: null,
        showVoting: false,
        ActivityType: 'Visitors',
        form: [],
      },
    });
  }

  return actions;
}
